import { render, staticRenderFns } from "./vueinfo.vue?vue&type=template&id=6bbc7717&scoped=true"
import script from "./vueinfo.vue?vue&type=script&lang=js"
export * from "./vueinfo.vue?vue&type=script&lang=js"
import style0 from "./vueinfo.vue?vue&type=style&index=0&id=6bbc7717&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc7717",
  null
  
)

export default component.exports